var _classCallCheck = require("/Users/ramirogonzalez/Xivis/POAP/poap-webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Users/ramirogonzalez/Xivis/POAP/poap-webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ramirogonzalez/Xivis/POAP/poap-webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var ProviderSubprovider = require('./json-rpc-engine-middleware');

var createFilterMiddleware = require('eth-json-rpc-filters');

var SubscriptionsSubprovider = /*#__PURE__*/function (_ProviderSubprovider) {
  "use strict";

  _inherits(SubscriptionsSubprovider, _ProviderSubprovider);

  var _super = _createSuper(SubscriptionsSubprovider);

  function SubscriptionsSubprovider() {
    _classCallCheck(this, SubscriptionsSubprovider);

    return _super.call(this, function (_ref) {
      var blockTracker = _ref.blockTracker,
          provider = _ref.provider,
          engine = _ref.engine;
      return createFilterMiddleware({
        blockTracker: blockTracker,
        provider: provider
      });
    });
  }

  return SubscriptionsSubprovider;
}(ProviderSubprovider);

module.exports = SubscriptionsSubprovider;